const initStatusMap = {};
function getGlobalSlardarInitStatus(globalSlardarName) {
  const initStatus = initStatusMap[globalSlardarName] || createInitStatus(globalSlardarName);
  initStatusMap[globalSlardarName] = initStatus;
  return initStatus;
}
function globalSlardarInstanceGetter(slardarName) {
  return window[slardarName];
}
function createInitStatus(globalSlardarName) {
  let loaded = typeof window[globalSlardarName].create === "function";
  const initPromise = loaded ? Promise.resolve(true) : new Promise((resolve) => {
    window[globalSlardarName]("on", "init", () => {
      loaded = true;
      resolve(true);
    });
  });
  const result = {
    slardarName: globalSlardarName,
    loaded,
    initPromise,
    instanceGetter: globalSlardarInstanceGetter.bind(null, globalSlardarName)
  };
  return result;
}
export {
  getGlobalSlardarInitStatus
};

//# sourceMappingURL=global-slardar-on-init.js.map